import SettingFrame from "../../../../components/@settings/SettingFrame";
import UpdateUserRole from "../../../../components/@user_roles/roles/UpdateUserRole"

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function UserRoleUpdatePage() {

    // return UpdateUserRole({
    //     routeType: routeTypes.admin
    // })

    let routeType = routeTypes.admin

    return (
        <SettingFrame
            routeType={routeType}
        >
            <UpdateUserRole
                routeType={routeType}
            />
        </SettingFrame>
    )
}